module.exports = "/_next/static/images/DataCollection@2x-8c44e7278db4442b53e69a5419b59314.png";